module.exports = __webpack_public_path__ + "img/prop-bird-right.463aa123.png";